import { useEffect } from 'react';
import { api } from '../lib/api';

// Heartbeat every 15s while the agent UI is open.
export function usePresence(tenantCode: string | undefined, agentUid: string | undefined) {
  useEffect(() => {
    if (!tenantCode || !agentUid) return;
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      api.presence(tenantCode, agentUid, document.hidden ? 'busy' : 'online').catch(() => {});
    };
    tick();
    const id = setInterval(tick, 15_000);
    const onVisibility = () => tick();
    document.addEventListener('visibilitychange', onVisibility);
    const onUnload = () => {
      navigator.sendBeacon?.(
        '/api/agent/presence',
        new Blob([JSON.stringify({ tenantCode, agentUid, status: 'offline' })], {
          type: 'application/json',
        })
      );
    };
    window.addEventListener('beforeunload', onUnload);
    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('beforeunload', onUnload);
      api.presence(tenantCode, agentUid, 'offline').catch(() => {});
    };
  }, [tenantCode, agentUid]);
}
